<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CTabs variant="tabs" :active-tab="0">
                <!--  Tab General -->
                <CTab :title="$t('general')">
                    <ProviderViewGeneralTab
                        :provider="provider"
                        v-if="!storePageLoading" 
                        :mode="viewType" 
                    />
                </CTab>
                <CTab :title="$t('origins')" :disabled="!provider.uuid"> 
                    <ProviderViewOriginsTab
                        :provider="provider"
                        v-if="!storePageLoading" 
                        :mode="viewType" 
                    />
                </CTab>
            </CTabs>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import SelectCountry from "£lement/SelectCountry";
import SelectLanguage from "£lement/SelectLanguage";
import ButtonSave from "~/components/ButtonSave";
import ProviderViewGeneralTab from "./Components/ProviderViewGeneralTab.vue";
import ProviderViewOriginsTab from "./Components/ProviderViewOriginsTab.vue";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import { validationMixin } from "vuelidate";

/** Other */

export default {
    name: "ProvidersViewPage",
    middleware: ["auth", "page"],
    mixins: [validationMixin, pageMixin],
    components: {
        SelectCountry,
        SelectLanguage,
        ButtonSave,
        ProviderViewGeneralTab,
        ProviderViewOriginsTab,
    },
    data() {
        return {
            provider: {
                uuid: null,
                name: null,
                cif: null,
                address: null,
                province: null,
                cp: null,
                country_id: null,
                language_id: null,
            },
        };
    },
    computed: {
        viewType: function () {
            return this.routeName.includes("edit") ? "edit" : "create";
        },
        uuid: function () {
            return this.$route.query.uuid;
        }
    },
    methods: {
        async loadProvider(){
            this.provider = await this.fetcher({ 
                url: `/provider_group/${this.uuid}`,
                method: 'GET'
            }); 
        }
    },
    async mounted() {
        if(this.uuid)
            await this.loadProvider();
        this.updatePageLoading(false);
    },
};
</script>

<style>
</style>